import React from 'react';
import Clipboard from 'react-clipboard.js';
import { generateHash } from 'src/helpers/hashId';
import { buildUrl } from 'src/helpers/url';
import { ShareActionOptions } from 'src/redux/modules/page';
import Svg from '@jg/svg';
import linkIcon from '@jg/icons/lib/link.svg';
import styles from './CopyLinkShareButton.scss';
import CSSModules from 'react-css-modules';

interface Props {
  copyText: string;
  copiedText: string;
  isDisabled?: boolean;
  pageSection: string;
  socialShareUrl: string;
  sharePageLink: (options: ShareActionOptions) => void;
}

interface State {
  copied: boolean;
  copyLinkUrl: string;
  copyLinkUtmTerm: string;
}

class CopyLinkShareButton extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { copied: false, ...this.generateCopyLinkState() };
  }

  onCopyUrlToClipboardSuccess = () => {
    const { pageSection, sharePageLink } = this.props;
    const { copyLinkUtmTerm } = this.state;

    sharePageLink({ shareHash: copyLinkUtmTerm, location: pageSection });

    this.setState({ copied: true });

    setTimeout(() => {
      this.setState({ copied: false, ...this.generateCopyLinkState() });
    }, 5000);
  };

  generateCopyLinkState = () => {
    const { socialShareUrl } = this.props;
    const utmTerm = generateHash();
    const url = buildUrl(socialShareUrl, { utm_term: utmTerm });

    return { copyLinkUrl: url, copyLinkUtmTerm: utmTerm };
  };

  render() {
    const { copyText, copiedText, isDisabled } = this.props;
    const buttonText = !this.state.copied ? copyText : copiedText;

    return (
      <div className={styles.copy}>
        <Svg
          name="link"
          markup={linkIcon}
          className="jg-icon jg-fill--nobel jg-position-absolute"
        />
        <div className={styles.url}>{this.state.copyLinkUrl}</div>
        <Clipboard
          button-disabled={isDisabled}
          data-clipboard-text={this.state.copyLinkUrl}
          onSuccess={this.onCopyUrlToClipboardSuccess}
        >
          {buttonText}
        </Clipboard>
      </div>
    );
  }
}

export default CSSModules(CopyLinkShareButton, styles);



// WEBPACK FOOTER //
// ./src/components/ShareModal/CopyLinkShareButton.tsx